export enum CategoryModal {
  ADD = 1,
  EDIT = 2,
  DELETE = 3,
}
